module.exports = __webpack_public_path__ + "img/bannertop.c1f819b.jpg";